import React, { Component } from "react";
import { UserContext } from "context/userProvider";
import { Button, Icon, Pagination, Table } from "semantic-ui-react";
import LetterLoading from "components/loading/letterLoading";
import Navigation from "components/navigation";
import Sidebar from "components/sidebar";
import "scss/screens/setting/users/userList.scss";
import AddTeamModal from "components/modals/users/addTeamModal";
import Swal from "sweetalert2";
export const END_POINT = "http://119.63.68.113:9090";

export default class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      first_name: "",
      last_name: "",
      name: "",
      email: "",
      phone_no: "",
      role: "admin",
      team: 0,
      team_name: "",
      position: 0,
      selectTeam: "",
      image1: "",
      imagePreviewUrl1: "",
      image2: "",
      imagePreviewUrl2: "",
      addUserModal: false,
      editUserModal: false,
      addTeamModal: false,
      member_detail: {},
      showPassword: false,
      isLoading: true,
      selectProFile: [],
      selectSign: [],
      profileImagePath: "",
      signImagePath: "",
      user_detail: {},
    };
  }

  startLoading = () => this.setState({ isLoading: true });
  stopLoading = () => this.setState({ isLoading: false });
  setAddTeamModal = () => this.setState((prevState) => ({ addTeamModal: !prevState.addTeamModal }));
  setAddUserModal = () => this.setState((prevState) => ({ addUserModal: !prevState.addUserModal }));

  componentDidMount() {
    // const { user } = this.context;
    this.startLoading();
    this.fetchData();
    // this._handleLoading();
    // this.setState({
    //   profileImagePath: `${END_POINT}/get/image?name=profileimage-${user.id}.png&path=officer`,
    //   signImagePath: `${END_POINT}/get/image?name=signimage-${user.id}.png&path=officer`,
    // });
  }

  async fetchData() {
    await this.setUserTeams({ team_id: 0 });
    await this.setUserList({ team_id: -1, role: "" });
    this.stopLoading();
  }

  onSelectImage = (e, process) => {
    this.setState({
      [process]: [e.target.files[0]],
      // selectFiles: [e.target.files[0]],
    });
  };

  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  toggleAddUserModal = () => {
    this.setState({
      addUserModal: !this.state.addUserModal,
    });
  };

  toggleEditUserModal = () => {
    this.setState({
      editUserModal: !this.state.editUserModal,
    });
  };

  toggleAddTeamModal = () => {
    this.setState({
      addTeamModal: !this.state.addTeamModal,
    });
  };

  setUserTeams = async (data) => {
    const { getTeams } = this.context;
    await getTeams(data);
  };

  _handleCheckBoxPosition = (position) => {
    // console.log(position);
    this.setState({ role: position });
  };

  setUserList = async (data) => {
    const { getClpUser } = this.context;
    await getClpUser(data);

    console.log("clpUserList", data);
    const filteredClpUserList = this.context.clpUserList.filter(user => user.is_delete === 0);
  
    this.setState({
      userList: filteredClpUserList.slice(this.state.begin, this.state.end),
    });
  };

  createTeamList = () => {
    const { teamList } = this.context;
    return (
      <>
        <div className="create" onClick={() => this.setAddTeamModal()}>
          <Icon name="plus" />สร้างทีมงาน
        </div>
        {teamList != null &&
          teamList?.teams?.map((team) => (
            <div
              className="list"
              key={team.id}
              onClick={() => this.setUserList({ team_id: team.id, role: "" })}>
              {team.name}
            </div>
          ))}
      </>
    );
  };

  createUserList = () => {
    const { userList } = this.context;
    return (
      <>
        <div className="create" onClick={() => this.setAddUserModal()}>
          <Icon name="plus" />สร้างทีมงาน
        </div>

        {userList != null &&
          userList?.teams?.map((team) => (
            <div
              className="list"
              key={team.id}
              onClick={() => this.setUserList({ team_id: team.id, role: "" })}>
              {team.name}
            </div>
          ))}
      </>
    );
  }
  confirmAction = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  deleteUesrs = async (name) => {
    const { deleteUsers } = this.context;
    const data = {
      name: name,
    };

    // แสดงข้อความยืนยันการลบ
    const confirmDelete = await this.confirmAction("คุณต้องการลบข้อมูลผู้ใช้งาน" +  name  + " ใช่หรือไม่?");
    if (!confirmDelete) {
      return; // ไม่ทำอะไรเมื่อผู้ใช้ยกเลิกการลบ
    }

    const formData = new FormData()
    formData.append("data", JSON.stringify(data));
    // statusForm = "delete";
    console.log("datadelete", data);
    
    let result = await deleteUsers(data);
    if (result?.result === "success") {  
      return this.alertDialog("สำเร็จ!", "ลบข้อมูลสำเร็จ", "success");   
    } else {
      return this.alertDialog("ผิดพลาด!", "ลบข้อมูลไม่สำเร็จ", "warning");
    } 
  };

  alertDialog = async (title, text, icon) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: "ok",
      confirmButtonColor: "#3085d6",
    });
  };

  setDataToRegisterUser = async () => {
    const {
      username,
      password,
      role,
      first_name,
      last_name,
      email,
      phone_no,
      position,
    } = this.state;

    const formData = new FormData();
    if (username.length >= 4 || username.length <= 16) {
      if (password.length >= 4 || password.length <= 16) {
        if (role !== "") {
          const data = {
            id: username,
            passwd: password,
            firstname: first_name,
            lastname: last_name,
            email: email,
            phone_no: phone_no,
            role: role,
            team_id: position,
          };

          formData.append("data", JSON.stringify(data));
          this.state.selectSign.map((image) =>
            formData.append("sign_image", image)
          );
          this.state.selectProFile.map((image) =>
            formData.append("profile_image", image)
          );

          const result = await this.context.userClpRegister(formData);
          if (result.status.result === "success") {
            return this.alertDialog("สำเร็จ!", result.status.description, "success");
          } else {
            return this.alertDialog("ผิดพลาด!", result.status.description, "warning");
          }
        } else {
          alert("กรุณาเลือกตำแหน่งงาน");
        }
      } else {
        alert("กรุณากรอกรหัสผ่านไม่ตำ่กว่า 4 ตัว และไม่เกิน 16 ตัว");
      }
    } else {
      alert("กรุณากรอกชื่อผู้ใช้งานไม่ตำ่กว่า 4 ตัว และไม่เกิน 16 ตัว");
    }
  };

  setDataToUpdateUser = async (user_detail) => {
    const {
      username,
      password,
      role,
      first_name,
      last_name,
      email,
      phone_no,
      position,
    } = this.state;
    const formData = new FormData();

    if (username.length >= 4 || username.length <= 16) {
      if (password.length >= 4 || password.length <= 16) {
        if (role !== "") {
          const data = {
            old_username: user_detail.id,
            username: username || user_detail.id,
            password: password || user_detail.password,
            firstname: first_name || user_detail.firstname,
            lastname: last_name || user_detail.lastname,
            email: email || user_detail.email,
            phone_no: phone_no || user_detail.phone_no,
            role: role || user_detail.role,
            team_id: position || user_detail.team_id,
          };

          formData.append("data", JSON.stringify(data));
          this.state.selectSign.map((image) =>
            formData.append("sign_image", image)
          );
          this.state.selectProFile.map((image) =>
            formData.append("profile_image", image)
          );

          const result = await this.context.userClpUpdate(formData);
          if (result && result.status && result.status.result === "success") {
            return this.alertDialog("สำเร็จ!", "อัพเดทข้อมูลพนักงานสำเร็จ", "success");
          } else {
            return this.alertDialog("ผิดพลาด!", result.status.description, "warning");
          }
        } else {
          alert("กรุณาเลือกตำแหน่งงาน");
        }
      } else {
        alert("กรุณากรอกรหัสผ่านไม่ตำ่กว่า 4 ตัว และไม่เกิน 16 ตัว");
      }
    } else {
      alert("กรุณากรอกชื่อผู้ใช้งานไม่ตำ่กว่า 4 ตัว และไม่เกิน 16 ตัว");
    }
  };

  createUserTable = () => {
    const { userList } = this.state;
    console.log("userList", userList);
    return (
      <Table celled striped selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>ชื่อพนักงาน</Table.HeaderCell>
            <Table.HeaderCell>อีเมล</Table.HeaderCell>
            <Table.HeaderCell>บทบาท</Table.HeaderCell>
            <Table.HeaderCell>สถานะ</Table.HeaderCell>
            {/* <Table.HeaderCell>ทีม</Table.HeaderCell> */}
            <Table.HeaderCell>แก้ไขข้อมูล</Table.HeaderCell>
            <Table.HeaderCell>ลบข้อมูล</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {userList?.map((user, idx) => (
            <Table.Row key={idx}>
              <Table.Cell>{user.name}</Table.Cell>
              <Table.Cell>{user.email}</Table.Cell>
              <Table.Cell>
                {user.role === "manager" ? "Manager"
                  : user.role === "sc" ? "Service Call Center"
                    : user.role === "sa" ? "Service Admin"
                      : user.role === "en" ? "Engineer"
                        : "Service Team"}
              </Table.Cell>
              <Table.Cell>
                {user.is_active === 1 ? "ใช้งาน" : "ยกเลิก"}
              </Table.Cell>
              {/* <Table.Cell>{user.team_id}</Table.Cell> */}
              <Table.Cell>
                <Button color="yellow" onClick={() => {
                  this.toggleEditUserModal(
                    this.setState({ 
                      userDetail: user,
                      role: user.role, 
                      profileImagePath: `${END_POINT}/get/image?name=profileimage-${user.id}.png&path=officer`,
                      signImagePath: `${END_POINT}/get/image?name=signimage-${user.id}.png&path=officer`,
                    })
                  );
                }}>
                  <Icon name="edit" />
                  แก้ไข
                </Button>
              </Table.Cell>
              <Table.Cell>
                <Button  
                  className="action-btn"
                  style={{
                    fontFamily: "Kanit",
                    fontSize: "16px",
                    backgroundColor: "#ff6347",
                  }} 
                    onClick={() => this.deleteUesrs(user.name)}>      
                  ลบข้อมูล
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  };

  paginationUpdate = (e, data) => {
    const { clpUserList } = this.context;
    const { pageSize } = this.state;

    let beginIdx = (data.activePage - 1) * pageSize;
    let endIdx = data.activePage * pageSize;

    this.setState({ activePage: data.activePage });
    this.setState({
      userList: [...clpUserList.slice(beginIdx, endIdx)],
    });
  };

  render() {
    const { isLoading, activePage, pageSize, addTeamModal, showPassword, userDetail } = this.state;
    const { clpUserList, teamList } = this.context;

    return (
      <div className="userList">
        <LetterLoading isOpen={isLoading} />
        <Navigation />
        <Sidebar tabActive="setting" setting="users" />
        <AddTeamModal isOpen={addTeamModal} isClose={this.setAddTeamModal} />

        <div className="userList-content">
          <h2>การตั้งค่า</h2>
          <hr />
          <div className="userList-content-user">
            <div className="header">
              <h3>
                <Icon name="users" />
                &nbsp;ตั้งค่าผู้ใช้งาน
              </h3>
              <div>
                <Button color="green" onClick={this.toggleAddUserModal}>
                  <Icon name="user plus" />
                  เพิ่มผู้ใช้งานใหม่
                </Button>
              </div>
            </div>
            <hr />

            <div className="teams">
              <div className="teams-list">
                ทีมทั้งหมด ({teamList?.total_team})
                {this.createTeamList()}
              </div>
            </div>

            <div className="users">
              <div className="users-list">
                พนักงานทั้งหมด ({clpUserList.length})
                {this.createUserTable()}
              </div>
              <div className="users-pagination">
                <Pagination
                  activePage={activePage}
                  totalPages={Math.ceil(clpUserList.length / pageSize)}
                  onPageChange={this.paginationUpdate}
                />
              </div>
            </div>

            {/* Add CLP User Modal */}
            {this.state.addUserModal && (
              <div className="modal show" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                  <div className="userList-content-user">
                    <div className="header">
                      <h3>
                        <Icon name="user plus" />
                        &nbsp; เพิ่มพนักงาน
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={this.toggleAddUserModal}
                      >
                        <Icon name="close red" />
                      </button>
                    </div>
                    <hr />

                    <div style={{ fontSize: "16px" }}>
                      <div className="row">
                        <div className="col">
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{
                                textAlign: "center",
                                margin: "5px auto",
                                height: "200px",
                                width: "250px",
                                border: "1px solid gray",
                                borderTop: "5px solid gray",
                                borderBottom: "5px solid gray",
                                backgroundColor: "#D5D5D5",
                              }}
                            >
                              {this.state.selectProFile.length > 0 ? (
                                <img
                                  alt="profile_image"
                                  src={URL.createObjectURL(this.state.selectProFile[0])}
                                  style={{
                                    height: 190,
                                    width: 220,
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <img
                                  alt="profile_image"
                                  src={this.state.profileImagePath}
                                  style={{
                                    height: 190,
                                    width: 220,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                            </div>
                            <input
                              ref="profile_image"
                              onChange={(e) => this.onSelectImage(e, "selectProFile")}
                              type="file"
                              style={{ display: "none" }}
                              multiple={false}
                            />
                            <div style={{ marginTop: "10px" }}>
                              <button
                                className="btn btn-warning btn-sm"
                                style={{ fontSize: "16px", color: "#000000" }}
                                onClick={() => this.refs.profile_image.click()}
                              >
                                <i className="fas fa-camera"></i>
                                &nbsp;อัพโหลดรูปโปรไฟล์
                              </button>
                            </div>
                          </div>

                          <br />
                          <br />

                          <div style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <div
                                style={{
                                  margin: "5px 90px",
                                  height: "100px",
                                  width: "200px",
                                  border: "1px solid gray",
                                  borderTop: "5px solid gray",
                                  borderBottom: "5px solid gray",
                                  backgroundColor: "#D5D5D5",
                                }}
                              >
                                {this.state.selectSign.length > 0 ? (
                                  <img
                                    alt="sign_profile"
                                    src={URL.createObjectURL(this.state.selectSign[0])}
                                    style={{
                                      height: 80,
                                      width: 180,
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <img
                                    alt="sign_profile"
                                    src={this.state.signImagePath}
                                    style={{
                                      height: 80,
                                      width: 180,
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>
                              <input
                                ref="sign_image"
                                onChange={(e) => this.onSelectImage(e, "selectSign")}
                                type="file"
                                style={{ display: "none" }}
                                multiple={false}
                              />
                              <div style={{ marginTop: "10px" }}>
                                <button
                                  className="btn btn-warning btn-sm"
                                  style={{ fontSize: "16px", color: "#000000" }}
                                  onClick={() => this.refs.sign_image.click()}
                                >
                                  <i className="fas fa-signature"></i>
                                  &nbsp;อัพโหลดรูปลายเซ็น
                                </button>
                              </div>
                            </div>
                          </div>

                          <br />
                          <br />
                          <br />
                          <br />

                          <div className="col">
                            <h3>
                              <Icon name="cog" />
                              &nbsp; ตั้งค่าผู้ใช้งาน
                            </h3>
                            <hr />
                            <div className="row">
                              <div className="col">
                                ชื่อผู้ใช้งาน
                                <span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="ชื่อผู้ใช้งาน"
                                  // defaultValue={userDetail.id}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({ username: userDetail.id })
                                      : this.setState({ username: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">
                                ชื่อ<span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="ชื่อ"
                                  // defaultValue={userDetail.firstname}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({ first_name: userDetail.firstname })
                                      : this.setState({ first_name: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">
                                นามสกุล<span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="นามสกุล"
                                  // defaultValue={userDetail.lastname}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({ last_name: userDetail.lastname })
                                      : this.setState({ last_name: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">ทีมงาน</div>
                              <div className="col-9">
                                <select
                                  className="browser-default custom-select"
                                  // defaultValue={userDetail.team_id || 0}
                                  onChange={(e) => this.setState({ position: e.target.value })}
                                >
                                  {teamList?.teams.map((team, idx) => (
                                    <option key={idx} value={team.id}>
                                      {team.name}
                                    </option>
                                  ))}
                                  <option value={0}>อื่นๆ</option>
                                  {console.log(userDetail)}
                                </select>
                              </div>
                            </div>

                            <div style={{ marginTop: "1%" }}>ตำแหน่งงาน</div>
                            <div style={{ marginLeft: "5%" }}>
                              <div>
                                <div
                                  className={this.state.role === "manager" ? "checked-option" : "option"}
                                  onClick={(e) => this._handleCheckBoxPosition("manager")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.role === "manager"}
                                    onChange={(e) => this._handleCheckBoxPosition("manager")}
                                  />
                                  <label>&ensp;Manager</label>
                                </div>
                                <div
                                  className={this.state.role === "sa" ? "checked-option" : "option"}
                                  onClick={(e) => this._handleCheckBoxPosition("sa")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.role === "sa"}
                                    onChange={(e) => this._handleCheckBoxPosition("sa")}
                                  />
                                  <label>&ensp;Service Admin</label>
                                </div>
                                <div
                                  className={this.state.role === "st" ? "checked-option" : "option"}
                                  onClick={(e) => this._handleCheckBoxPosition("st")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.role === "st"}
                                    onChange={(e) => this._handleCheckBoxPosition("st")}
                                  />
                                  <label>&ensp;Service Team</label>
                                </div>
                                <div
                                  className={this.state.role === "sc" ? "checked-option" : "option"}
                                  onClick={(e) => this._handleCheckBoxPosition("sc")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.role === "sc"}
                                    onChange={(e) => this._handleCheckBoxPosition("sc")}
                                  />
                                  <label>&ensp;Service Call Center</label>
                                </div>
                                <div
                                  className={this.state.role === "en" ? "checked-option" : "option"}
                                  onClick={(e) => this._handleCheckBoxPosition("en")}
                                >
                                  <input
                                    type="checkbox"
                                    checked={this.state.role === "en"}
                                    onChange={(e) => this._handleCheckBoxPosition("en")}
                                  />
                                  <label>&ensp;Engineer</label>
                                </div>
                              </div>
                            </div>

                            <div style={{ marginTop: "4%" }}>
                              <div>
                                <h3>
                                  <Icon name="address book" />
                                  &nbsp; ข้อมูลการติดต่อ
                                </h3>
                                <hr />
                              </div>
                              <div>
                                <div>เบอร์โทรศัพท์</div>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="เบอร์โทรศัพท์"
                                    onChange={(e) => this.setState({ phone_no: e.target.value })}
                                  />
                                </div>
                              </div>
                              <div style={{ marginTop: "1%" }}>
                                <div>อีเมล</div>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="อีเมล"
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                  />
                                </div>
                              </div>
                              <div style={{ marginTop: "4%" }}>
                                <div>
                                  <h3>
                                    <Icon name="lock" />
                                    &nbsp; รหัสผ่าน
                                  </h3>
                                  <hr />
                                </div>
                              </div>
                              <div>
                                <div>รหัสผ่าน</div>
                                <div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="รหัสผ่าน"
                                    defaultValue={this.state.password}
                                    onChange={(e) => this.setState({ password: e.target.value })}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <br />
                      <b>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.toggleAddUserModal}
                          >
                            ยกเลิก
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => this.setDataToRegisterUser()}
                          >
                            เพิ่มพนักงาน
                          </button>
                        </div>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            )};

            {/* Edit CLP User */}
            {this.state.editUserModal && (
              <div className="modal show" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                  <hr />
                  <div className="userList-content-user">
                    <div className="header">
                      <h3>
                        <Icon name="edit" />
                        &nbsp; แก้ไขข้อมูลพนักงาน
                      </h3>
                      <button
                        type="button"
                        className="close"
                        onClick={this.toggleEditUserModal}
                      >
                        <Icon name="close red" />
                      </button>
                    </div>
                    <hr />
                    <div style={{ fontSize: "16px" }}>
                      <div className="row">
                        <div className="col">
                          <div style={{ textAlign: "center" }}>
                            <div
                              style={{
                                textAlign: "center",
                                margin: "5px auto",
                                height: "200px",
                                width: "250px",
                                border: "1px solid gray",
                                borderTop: "5px solid gray",
                                borderBottom: "5px solid gray",
                                backgroundColor: "#D5D5D5",
                              }}
                            >
                              {this.state.selectProFile.length > 0 ? (
                                <img
                                  alt="profile_image"
                                  src={URL.createObjectURL(this.state.selectProFile[0])}
                                  style={{
                                    height: 190,
                                    width: 220,
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <img
                                  alt="profile_image"
                                  src={this.state.profileImagePath}
                                  style={{
                                    height: 190,
                                    width: 220,
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                            </div>
                            <input
                              ref="profile_image"
                              onChange={(e) => this.onSelectImage(e, "selectProFile")}
                              type="file"
                              style={{ display: "none" }}
                              multiple={false}
                            />
                            <button
                              style={{ fontSize: "16px", color: "#000000" }}
                              onClick={() => this.refs.profile_image.click()}
                            >
                              <i className="fas fa-camera"></i>
                              &nbsp;อัพโหลดรูปโปรไฟล์
                            </button>
                            {/* {this.state.selectFiles[0]?.name} */}
                          </div>


                          <br />
                          <br />
                          <div style={{ textAlign: "center" }}>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                              <div
                                style={{
                                  margin: "5px 90px",
                                  height: "100px",
                                  width: "200px",
                                  border: "1px solid gray",
                                  borderTop: "5px solid gray",
                                  borderBottom: "5px solid gray",
                                  backgroundColor: "#D5D5D5",
                                }}
                              >
                                {this.state.selectSign.length > 0 ? (
                                  <img
                                    alt="sign_profile"
                                    src={URL.createObjectURL(this.state.selectSign[0])}
                                    style={{
                                      height: 80,
                                      width: 180,
                                      objectFit: "cover",
                                    }}
                                  />
                                ) : (
                                  <img
                                    alt="sign_profile"
                                    src={this.state.signImagePath}
                                    style={{
                                      height: 80,
                                      width: 180,
                                      objectFit: "cover",
                                    }}
                                  />
                                )}
                              </div>
                              <input
                                ref="sign_image"
                                onChange={(e) => this.onSelectImage(e, "selectSign")}
                                type="file"
                                style={{ display: "none" }}
                                multiple={false}
                              />
                              <div>
                                <button
                                  style={{ fontSize: "16px", color: "#000000" }}
                                  onClick={() => this.refs.sign_image.click()}
                                >
                                  <i className="fas fa-signature"></i>
                                  &nbsp;อัพโหลดรูปลายเซ็น
                                </button>
                              </div>
                            </div>
                          </div>

                          <div className="col">
                            <h3>
                              <Icon name="cog" />
                              &nbsp; ตั้งค่าผู้ใช้งาน
                            </h3>
                            <hr />
                            <div className="row">
                              <div className="col">
                                ชื่อผู้ใช้งาน
                                <span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="ชื่อผู้ใช้งาน"
                                  defaultValue={userDetail.id}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({
                                        username: userDetail.id,
                                      })
                                      : this.setState({ username: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">
                                ชื่อ<span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="ชื่อ"
                                  defaultValue={userDetail.firstname}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({
                                        first_name: userDetail.firstname,
                                      })
                                      : this.setState({
                                        first_name: e.target.value,
                                      })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">
                                นามสกุล<span style={{ color: "#FF0000" }}>*</span>
                              </div>
                              <div className="col-9">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="นามสกุล"
                                  defaultValue={userDetail.lastname}
                                  onChange={(e) =>
                                    e.target.value === ""
                                      ? this.setState({
                                        last_name: userDetail.lastname,
                                      })
                                      : this.setState({ last_name: e.target.value })
                                  }
                                />
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "1%" }}>
                              <div className="col">ทีมงาน</div>
                              <div className="col-9">
                                <select
                                  className="browser-default custom-select"
                                  defaultValue={userDetail.team_id || 0}
                                  onChange={(e) =>
                                    this.setState({ position: e.target.value })
                                  }
                                >
                                  {teamList.teams.map((team, idx) => (
                                    <option key={idx} value={team.id}>
                                      {team.name}
                                    </option>
                                  ))}
                                  <option value={0}>อื่นๆ</option>
                                  {console.log(userDetail)}
                                </select>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: "3%" }}>
                              <div className="col">
                                <div style={{ marginTop: "1%" }}>ตำแหน่งงาน</div>
                                <div style={{ marginLeft: "5%" }}>
                                  <div>
                                    <div
                                      onClick={(e) =>
                                        this._handleCheckBoxPosition("manager")
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.role === "manager"}
                                        onChange={() =>
                                          this._handleCheckBoxPosition("manager")
                                        }
                                      />
                                      <label>&ensp;Manager</label>
                                    </div>
                                    <div
                                      onClick={(e) =>
                                        this._handleCheckBoxPosition("sa")
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.role === "sa"}
                                        onChange={(e) =>
                                          this._handleCheckBoxPosition("sa")
                                        }
                                      />
                                      <label>&ensp;
                                        Service Admin</label>
                                    </div>
                                    <div
                                      onClick={(e) =>
                                        this._handleCheckBoxPosition("st")
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.role === "st"}
                                        onChange={(e) =>
                                          this._handleCheckBoxPosition("st")
                                        }
                                      />
                                      <label> Service Team</label>
                                    </div>
                                    <div
                                      onClick={(e) =>
                                        this._handleCheckBoxPosition("sc")
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.role === "sc"}
                                        onChange={(e) =>
                                          this._handleCheckBoxPosition("sc")
                                        }
                                      />
                                      <label> Service Call Center</label>
                                    </div>
                                    <div
                                      onClick={(e) =>
                                        this._handleCheckBoxPosition("en")
                                      }
                                    >
                                      <input
                                        type="checkbox"
                                        checked={this.state.role === "en"}
                                        onChange={(e) =>
                                          this._handleCheckBoxPosition("en")
                                        }
                                      />
                                      <label> Engineer</label>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            </div>

                            <div style={{ marginTop: "4%" }}>
                              <div>
                                <h3>
                                  <Icon name="address book" />
                                  &nbsp; ข้อมูลการติดต่อ
                                </h3>
                                <hr />
                              </div>
                              <div className="row">
                                <div className="col">เบอร์โทรศัพท์</div>
                                <div className="col-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="เบอร์โทรศัพท์"
                                    defaultValue={userDetail.phone_no}
                                    onChange={(e) =>
                                      e.target.value === ""
                                        ? this.setState({
                                          phone_no: userDetail.phone_no,
                                        })
                                        : this.setState({ phone_no: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: "1%" }}>
                                <div className="col">อีเมล</div>
                                <div className="col-9">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="อีเมล"
                                    defaultValue={userDetail.email}
                                    onChange={(e) =>
                                      e.target.value === ""
                                        ? this.setState({
                                          email: userDetail.email,
                                        })
                                        : this.setState({ email: e.target.value })
                                    }
                                  />
                                </div>
                              </div>
                              <div className="row" style={{ marginTop: "4%" }}>
                                <div className="col">
                                  <h3>
                                    <Icon name="lock" />
                                    &nbsp; รหัสผ่าน
                                  </h3>
                                  <hr />
                                </div>
                              </div>
                              <div className="row">
                                <div
                                  className="col"
                                  style={{ display: "flex", alignItems: "center" }}
                                >
                                  รหัสผ่าน
                                </div>
                                <div className="col-9">
                                  <button
                                    className="btn btn-sm"
                                    style={{ fontSize: "16px", backgroundColor: "#00bcd4", color: "#fff" }}
                                    onClick={() => this.toggleShowPassword()}
                                  >
                                    {showPassword === false ? (
                                      <div>
                                        <i className="far fa-eye"></i>
                                        &ensp;แสดงรหัสผ่าน
                                      </div>
                                    ) : (
                                      <div>
                                        <i className="far fa-eye-slash"></i>
                                        &ensp;ปิดรหัสผ่าน
                                      </div>
                                    )}
                                  </button>
                                  {showPassword && (
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="รหัสผ่าน"
                                      defaultValue={userDetail.password}
                                      onChange={(e) =>
                                        e.target.value === ""
                                          ? this.setState({
                                            password: userDetail.password,
                                          })
                                          : this.setState({
                                            password: e.target.value,
                                          })
                                      }
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br/>
                      <b>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={this.toggleEditUserModal}
                          >
                            ยกเลิก
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={(e) => this.setDataToUpdateUser(userDetail)}
                          >
                            อัพเดทข้อมูลพนักงาน
                          </button>
                        </div>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            )};
          </div>
        </div >
      </div >
    );
  }
}
UserList.contextType = UserContext;

